import { render, staticRenderFns } from "./ScrollUp.vue?vue&type=template&id=ae557aae"
import script from "./ScrollUp.vue?vue&type=script&lang=js"
export * from "./ScrollUp.vue?vue&type=script&lang=js"
import style0 from "./ScrollUp.vue?vue&type=style&index=0&id=ae557aae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports